module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('strong', [_c('em', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "big1"
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('strong', [_c('em', [_vm._v("I")])])]), _vm._v(" pump the pedals of my bike as I race to Gig’s house. The breeze cools my face, and the sun’s still high in the sky. Summer rocks. No school. No getting up early. And days that feel like they’ll last forever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I lift my hands from the handlebars and sit up straight. Freedom. That’s what August is. No boring homework. No teachers and parents watching every move. Freedom to do what we want on a Friday night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Gig’s house, I lean my bike against the basketball hoop and climb the cement steps. The chimes of the doorbell echo in the house. Footsteps approach and the door opens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, Jackson,” Gig’s sister, Sydney, answers. “Come on in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Syd.” She’s wearing short shorts and a white tank top that shows off her tan. Her brown hair is held back in a "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("thin headband. She looks more like a beach girl than the tough second baseman I played with on the Panthers last spring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are you doing?” she asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Umm, fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks at me like I’ll say more. I’ve known her six years now—as long as I’ve known Gig—but lately I get tonguetied around her. Part of it is that she’s really smart. Part of it is that she’s Gig’s sister. But the main reason is that I’m not very good at talking to girls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When you and Gig are at soccer camp,” she says, “my mom and I are going to have fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stick my hands in the pockets of my cargo shorts and stand there like a dork. I don’t know what to say so I just kind of nod.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gig’s in his room,” Sydney says. “Probably killing something in some video game.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay.” I don’t know why talking to girls has gotten harder. When I was younger I used to be able to do it fine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gig’s got a new sign on his door:")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('strong', [_vm._v("STOP! KEEP OUT!")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("THIS MEANS YOU!"), _c('br'), _vm._v("ABSOLUTELY NO TRESPASSING!"), _c('br'), _vm._v("YOU’VE BEEN WARNED! YES, THIS MEANS YOU!")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("It means Sydney, not me, so I knock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Die, zombie scum,” Gig shouts over the noise of massive explosions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s me, Jackson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Open the door, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gig’s sitting shirtless with his hair sticking out in different directions, blasting zombies left and right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you playing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Extreme Zombie Invasion.” Gig’s eyes are locked on the screen. “I’m going to finally get to the Supreme Commander level.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I brush off boxers, two towels, and a bunch of video game cases and sit in the chair. My room’s a mess, but it’s nothing compared to this. Clothes, shoes, and empty Doritos bags cover the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you started packing yet?” I don’t see a bag.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What for?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Soccer camp.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("“I’m not going.” Gig stays focused on the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? You promised Diego, Isaac, and me that you’d go. Remember our deal with Diego to do this so he’ll play football with us? You can’t break it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was before my dad left for National Guard training.” Gig wipes out three more zombies. “When Dad left, he said I was the man of the house now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gig’s fingers fly at the controls. Like blasting zombies in a video game keeps his mom and Sydney safe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gig, you have to come. We’re signed up to room together. I don’t want some loser roomie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe they’ll let you have a single.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t want a single.” He can be so stupid sometimes. “I’m not crazy about soccer, either, but we all agreed we’d go to camp.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not about soccer.” Gig looks over at me. “I can’t go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Dun, dun da dunn")]), _vm._v(". “Sorry, loser, you failed.” A zombie screeches. “Try again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stop messing me up,” Gig shouts. “I was almost there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s go to Isaac’s. He and Diego said to come over.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No way,” Gig says. “I’m staying here until I beat this dumb game.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I’m not.” I get up and kick his baseball glove out "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("of the way. “You promised you’d go to camp. We all did. You can’t back out now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gig doesn’t even look up.")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('strong', [_c('em', [_vm._v("D")])])]), _vm._v("iego and Isaac are kicking a soccer ball in the backyard of Isaac’s house. Sweat glistens on Isaac’s dark skin and Diego’s got a new buzz cut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, what took you so long?” Isaac boots the ball to me and it skims across the thick grass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was at Gig’s.” I kick it to Diego.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ready for camp?” Diego passes the ball back to me. He’s big and strong, but he moves smoothly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Almost.” I slide the ball back and forth between my feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re going to have a blast.” Isaac wipes his face with his Lakers T-shirt. “There’s a girl’s camp at the same time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tap a pass to him. “Sweet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll meet a bunch of new girls.” Isaac tries a pass, but the ball hits a tree. “Maybe we’ll even get you a girlfriend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I track down the ball. Yeah, right. I’m having trouble even "), _c('em', [_vm._v("talking")]), _vm._v(" to girls. “We’ve got a problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” Isaac and Diego say together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gig’s not coming.” I pass to Diego, who traps it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?” he asks. “He promised.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("“He has to come,” Isaac says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, but he says since his dad’s gone, he has to stay home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did his dad really say that?” Diego drills me a pass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I dribble the ball around the birdbath. “He said Gig’s the man of the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gig’s the man?” Isaac laughs. “That’s one house I’m staying out of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He promised,” Diego repeats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s take some shots.” Isaac steals the ball from me and faces the side of the garage. “Who’s goalie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am.” Diego grabs two lawn chairs and sets them on each side. “Give me your best shot.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I push Isaac off the ball and kick a low shot that Diego swats away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that all you’ve got?” he taunts. “My grandma shoots harder than that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Those chairs are too close.” I pull one out a couple of feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re fine where they are.” Diego pulls it back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isaac lines up and sizzles a shot wide that smacks off the garage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I rebound the miss and rush toward Diego. I fake a shot "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("and he leans left. I turn and blast the ball just inside the chair. “He shoots! He scores!” I raise my arms above my head. “GOOOOOAL!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even without Gig, I’m excited about soccer camp.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81f596f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 69
// module chunks = 0